import { useTranslation } from 'react-i18next'

import { useInitData, useLinkLikeClick } from '../../../../../hooks'
import { getPostProfilePathname } from '../../../../../utils/link'
import { NewsboardPostAction } from '../NewsboardPostAction'
import { QA_NAME_COMMENTS_ACTION } from '../NewsboardPostFooter.constants'

import CommentsIcon from '../../../../../icons/comment-2.svg'

function NewsboardPostComments({ data }) {
  const { t } = useTranslation()

  const { availableSections } = useInitData()

  const { handleClick, handleMouseDown } = useLinkLikeClick()

  const postLink = getPostProfilePathname({ availableSections, id: data.uuid })

  function handleClickAction(event) {
    handleClick({ event, link: postLink })
  }

  function handleMouseDownAction(event) {
    handleMouseDown({ event, link: postLink })
  }

  return (
    <NewsboardPostAction
      Icon={CommentsIcon}
      qaName={QA_NAME_COMMENTS_ACTION}
      title={t('Newsboard.CommentsActionKey', {
        count: data?.counters?.comments,
      })}
      tooltip={t('Newsboard.CommentsActionTooltipKey')}
      onClick={handleClickAction}
      onMouseDown={handleMouseDownAction}
    />
  )
}

export default NewsboardPostComments
